var ArtifactGroupType;
(function (ArtifactGroupType) {
    ArtifactGroupType[ArtifactGroupType["FOUNDATIONS_OF_CIVILIZATION"] = 1] = "FOUNDATIONS_OF_CIVILIZATION";
    ArtifactGroupType[ArtifactGroupType["LEGENDS_OF_THE_HIGH_SEAS"] = 2] = "LEGENDS_OF_THE_HIGH_SEAS";
    ArtifactGroupType[ArtifactGroupType["TREASURES_OF_THE_NILE"] = 3] = "TREASURES_OF_THE_NILE";
    ArtifactGroupType[ArtifactGroupType["WHISPERS_OF_JADE"] = 4] = "WHISPERS_OF_JADE";
    ArtifactGroupType[ArtifactGroupType["ECHOES_OF_THE_NORTH"] = 5] = "ECHOES_OF_THE_NORTH";
    ArtifactGroupType[ArtifactGroupType["UNDER_THE_CEIBA"] = 6] = "UNDER_THE_CEIBA";
    ArtifactGroupType[ArtifactGroupType["LEGENDS_OF_TROY"] = 7] = "LEGENDS_OF_TROY";
    ArtifactGroupType[ArtifactGroupType["PATH_OF_INCENSE"] = 8] = "PATH_OF_INCENSE";
})(ArtifactGroupType || (ArtifactGroupType = {}));
export default ArtifactGroupType;
